import React from "react";
import {
  CircularProgress,
  Button,
  Typography,
  Container,
  Paper,
  Box,
} from "@mui/material";
import Navbar from "../../../globals/components/Navbar";
import GuestNavbar from "../GuestNavbar";
import SupportRequestModal from "../../../components/SupportRequestModal";
import useBlanketBondCreateHistoric from "./hooks/useBlanketBondCreateHistoric";
import BlanketHistoricBasicInformation from "./components/BlanketHistoricBasicInformation";
import BlanketHistoricDetailedInformation from "./components/BlanketHistoricDetailedInformation";
import BlanketHistoricObligeeInformation from "./components/BlanketHistoricObligeeInformation";
import BlanketHistoricOtherDetailsSection from "./components/BlanketHistoricOtherDetailsSection";
import BlanketHistoricBondNumberSection from "./components/BlanketHistoricBondNumberSection";

const BlanketBondCreateHistoric = () => {
  const {
    handleSubmit,
    control,
    watch,
    setValue,
    errors,
    isGuestBlanketRequest,
    isLoading,
    supportModalOpen,
    setSupportModalOpen,
    handleSupportRequestSubmit,
    submissionError,
    onSubmit,
    residencyStatus,
    otherResidency,
    allCities,
    allStates,
    allCounties,
    loadingCounties,
    obligees,
    loadingObligees,
    openObligeeDialog,
    setOpenObligeeDialog,
    newObligee,
    setNewObligee,
    emailExists,
    emailChecking,
    emailDialogOpen,
    emailDebounceRef,
    handleDialogClose,
    handleDialogContinue,
    handleDialogCancel,
    professionalGuardians,
    loadingGuardians,
    handleOtherResidencyChange,
    formatSSN,
    handleGoogleCallback,
    handleObligeeGoogleCallback,
    handleAddObligee,
  } = useBlanketBondCreateHistoric();

  return (
    <>
      {isGuestBlanketRequest ? <GuestNavbar /> : <Navbar />}
      <Container maxWidth="md" sx={{ mt: 6, mb: 6 }}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ fontWeight: "bold" }}
        >
          Guardianship Blanket Bond Request
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
        <Paper
          elevation={3}
            sx={{ p: 4, mb: 3, backgroundColor: "#f5f5f5", borderRadius: "15px" }}
        >
            <BlanketHistoricBasicInformation
              control={control}
              errors={errors}
              setValue={setValue}
              allCounties={allCounties}
              loadingCounties={loadingCounties}
              residencyStatus={residencyStatus}
              otherResidency={otherResidency}
              handleOtherResidencyChange={handleOtherResidencyChange}
              allCities={allCities}
              allStates={allStates}
              emailExists={emailExists}
              emailChecking={emailChecking}
              emailDialogOpen={emailDialogOpen}
              emailDebounceRef={emailDebounceRef}
              handleDialogClose={handleDialogClose}
              handleDialogContinue={handleDialogContinue}
              handleDialogCancel={handleDialogCancel}
              professionalGuardians={professionalGuardians}
              loadingGuardians={loadingGuardians}
              formatSSN={formatSSN}
              handleGoogleCallback={handleGoogleCallback}
            />
          </Paper>

          <Paper
            elevation={3}
            sx={{ p: 4, mb: 3, backgroundColor: "#f5f5f5", borderRadius: "15px" }}
          >
            <BlanketHistoricDetailedInformation
              control={control}
              errors={errors}
              watch={watch}
            />
          </Paper>

          <Paper
            elevation={3}
            sx={{ p: 4, mb: 3, backgroundColor: "#f5f5f5", borderRadius: "15px" }}
          >
            <BlanketHistoricObligeeInformation
              control={control}
              obligees={obligees}
              loadingObligees={loadingObligees}
              openObligeeDialog={openObligeeDialog}
              setOpenObligeeDialog={setOpenObligeeDialog}
              newObligee={newObligee}
              setNewObligee={setNewObligee}
              allCities={allCities}
              allStates={allStates}
              handleObligeeGoogleCallback={handleObligeeGoogleCallback}
              handleAddObligee={handleAddObligee}
              watch={watch}
            />
          </Paper>

          <Paper
            elevation={3}
            sx={{ p: 4, mb: 3, backgroundColor: "#f5f5f5", borderRadius: "15px" }}
          >
            <BlanketHistoricOtherDetailsSection control={control} errors={errors} />
          </Paper>

          <Paper
            elevation={3}
            sx={{ p: 4, mb: 3, backgroundColor: "#f5f5f5", borderRadius: "15px" }}
          >
            <BlanketHistoricBondNumberSection control={control} setValue={setValue} errors={errors} />
          </Paper>

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Button
                  disabled={isLoading}
              endIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                  type="submit"
                  variant="contained"
                  color="primary"
                >
                  Submit
                </Button>
            </Box>
          </form>
        <SupportRequestModal
          open={supportModalOpen}
          onClose={() => setSupportModalOpen(false)}
          onSubmit={handleSupportRequestSubmit}
          errorMessage={submissionError}
        />
      </Container>
    </>
  );
};

export default BlanketBondCreateHistoric;
